import { RoleType } from "common";
import { useAPI } from "../api/useAPI";
import { useSubscribeObservable } from "./useSubscribeObservable";

export const useIsInRole = (roleType: RoleType) => {
  const api = useAPI();
  const isInRole = useSubscribeObservable(api.isInRole(roleType));
  return isInRole ?? false;
};
